import { Link } from "react-router-dom";
import { useLang } from "../../i18n/LangContext";
import { TriaLogo, QuitandaSeal } from "./Mark";
import { LINKS } from "./Nav";
import { CONTACT_EMAIL } from "../../config";

export const Footer = () => {
  const { t } = useLang();
  const offices = t.contactPage.offices;
  return (
    <footer className="bg-[#0E1A1B] text-[#E9E4DA]" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-6 py-20 sm:px-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <TriaLogo dark />
          <p className="f-serif mt-8 text-3xl italic text-[#FAF8F5] lg:text-4xl">{t.footer.thesis}</p>
          <div className="mt-10"><QuitandaSeal sig={t.quitandaBlock.sig} dark /></div>
        </div>
        <nav className="flex flex-col gap-3 lg:col-span-3">
          {LINKS.map(([to, key]) => (
            <Link key={to} to={to} className="link-u w-fit text-sm" data-testid={`footer-nav-${key}`}>{t.nav[key]}</Link>
          ))}
        </nav>
        <div className="grid gap-8 text-sm leading-relaxed sm:grid-cols-2 lg:col-span-4 lg:grid-cols-1">
          {offices.map((o) => (
            <div key={o.city}>
              <p className="mb-2 text-[11px] uppercase tracking-[0.28em] text-[#FFCC00]">{o.city}</p>
              {o.addr.map((a) => <p key={a}>{a}</p>)}
            </div>
          ))}
          <a href={`mailto:${CONTACT_EMAIL}`} className="link-u w-fit" data-testid="footer-email">{CONTACT_EMAIL}</a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-[1400px] px-6 py-6 text-xs text-[#BDB6AA] sm:px-10">
          © 2026 TRIA · {t.footer.seal} · {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};
